import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import sellerGuideContent from '../../content/sellerGuideContent';

import {
  StaticContentArticle,
  StaticContentPageLayout,
} from '../StaticContentPage/StaticContentPage';

export const SellerGuideContent = props => (
  <StaticContentArticle content={sellerGuideContent} {...props} />
);

export const SellerGuidePageComponent = props => {
  const { scrollingDisabled } = props;
  return <StaticContentPageLayout content={sellerGuideContent} scrollingDisabled={scrollingDisabled} />;
};

SellerGuidePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const SellerGuidePage = compose(connect(mapStateToProps))(SellerGuidePageComponent);

export default SellerGuidePage;
